import React from 'react';
import cn from './primitives/cn';

/**
 * The × in a dialog's corner: the muted glyph with no surface of its own, darker under the
 * pointer, with the focus ring every control has.
 *
 * One component, so every dialog draws the same one. `Dialog` and `Modal.Header` use it,
 * and so does each dialog that still builds its own `.modal-header`. Those handed the glyph
 * to a secondary Button, whose hairline, shadow and 38px box drew a bordered tile in the
 * corner that no other dialog had (SURF-4838). main.css still places it
 * (`.module .modal-header button.close`); these utilities, which are `!important`, only
 * paint it.
 */
const CloseButton = React.forwardRef(({ className, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    aria-label="Close"
    className={cn(
      'close tw-bg-transparent tw-border-0 tw-p-1 tw-leading-none tw-rounded',
      'tw-text-muted tw-cursor-pointer hover:tw-text-ink',
      'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-brand-focus',
      'disabled:tw-opacity-50',
      className
    )}
    {...props}
  >
    <i className="fa fa-times" aria-hidden="true" />
  </button>
));
CloseButton.displayName = 'CloseButton';

export default CloseButton;
